var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsCodeBuildIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_5751)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09055 19.8087L6.19277 19.5038L2.82373 19.7865L4.48095 25.3327L8.09055 19.8087Z",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82373 13.4769V18.5126L4.52764 18.7441L7.84999 16.1585L4.52764 13.2495L2.82373 13.4769Z",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52762 20.1502L8.09054 19.8087V24.8553L4.52762 25.0978L3.1535 22.4677L4.52762 20.1502Z",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23907 12.4996L8.09018 12.2059L4.52726 6.61572L2.82373 12.2131L6.23907 12.4996Z",
    fill: "#3C4929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52765 6.36609L8.09057 7.15931V12.2059L4.52765 11.8678V6.36609ZM4.52765 13.26L8.09057 13.484V18.5344L4.52765 18.7621V13.26Z",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09057 10.7075L10.8151 10.1052L7.08125 5.28259L4.52765 10.2336L8.09057 10.7075Z",
    fill: "#3C4929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08124 5.16516L10.8151 6.15678V10.1052L7.08124 9.51001V5.16516Z",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8151 21.8876L8.0981 21.2853L4.52765 21.7626L7.08163 26.8533L10.8151 21.8876Z",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08125 22.4903L10.8151 21.8951V25.8582L7.08125 26.8536L3.70468 24.3746L7.08125 22.4903Z",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1496 12.2097L25.7342 12.4961L21.1816 11.7763L24.8921 5.15045L29.1496 12.2097Z",
    fill: "#3C4929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52764 21.763V20.1359L2.82373 19.7869V24.8226L7.08124 26.839V22.4866L4.52764 21.763Z",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1575 19.7903L25.7421 19.5038L21.1816 20.2274L24.8921 26.7173L29.1575 19.7903Z",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8921 5.15045L21.1816 6.13831V11.7763L24.8921 11.3539L28.9286 9.0473L24.8921 5.15045ZM24.8921 12.867L21.1816 13.1535V18.7915L24.8921 19.0708L28.9286 16.1031L24.8921 12.8673V12.867ZM24.8921 20.6757L21.1816 20.2496V25.8876L24.8921 26.8792L28.6255 22.8502L24.8921 20.6757Z",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0842 3.53052L8.35446 9.15009L12.15 9.80741L15.9964 8.95885L12.0842 3.53052Z",
    fill: "#3C4929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.623 11.0897L19.8233 11.5599L12.0842 10.3333L15.9965 0.978027L23.623 11.0897Z",
    fill: "#3C4929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9965 20.2902L23.3203 16.0113L15.9965 11.6992L12.0842 12.2281V19.7647L15.9965 20.2902Z",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9964 11.6992V20.2898L23.623 19.2613V12.7277L15.9964 11.6992Z",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.623 20.9145L19.8233 20.4409L12.0842 21.6712L15.9965 31.0551L23.623 20.9145Z",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9731 23.0298L12.1775 22.1888L8.3699 22.8499L11.9407 28.9946L15.9731 23.0298Z",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35032 22.8461V27.4409L15.9961 31.0588L23.1257 24.3742L15.9961 22.4681L12.0838 21.6711V23.9043L8.35032 22.8461ZM7.08124 9.50999V5.16514L2.82373 7.17775V12.2134L4.52764 11.8682V10.2336L7.08161 9.50999H7.08124ZM12.0842 8.09258V10.333L15.9964 9.53973L23.0368 7.63366L15.9961 0.948669L8.35032 4.56279V9.15008L12.0842 8.09258Z",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9964 0.941162V9.53937L23.623 11.0893V4.54813L15.9964 0.941162ZM29.1767 12.2172V7.17777L24.8921 5.15048V11.3468L29.1767 12.2172ZM29.1767 18.5122V13.4806L24.8921 12.9005V19.0931L29.1767 18.5122ZM15.9964 22.4681V31.0554L23.623 27.4451V20.9144L15.9964 22.4681ZM29.1767 24.8188V19.7869L24.8921 20.6573V26.8461L29.1767 24.8188Z",
    fill: "#759C3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_5751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCodeBuildIntegration);
export default __webpack_public_path__ + "static/media/aws-code-build-integration.49541f42b3ade17910e7008b2d71e075.svg";
export { ForwardRef as ReactComponent };